import { useQuery } from 'libs/query'
import { useAxiosPrivate } from 'shared/hooks'
import { useParams } from 'libs/router'
import { HistoryRes } from 'shared/types/general.types'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'

export const useFetchTagHistory = () => {
	const axiosPrivate = useAxiosPrivate()
	const params = useParams()

	const { data: tagHistory, isPending: isLoadingHistory } = useQuery<HistoryRes>({
		queryKey: queryKeys.tags.history(params.id as string),
		queryFn: () => axiosPrivate.get(apiRoutes.tagHistory(params.id as string))
	})

	return {
		tagHistory,
		isLoadingHistory
	}
}
